import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import UserManagement from "../user-management/UserManagement";
import EventManagement from "../event-management/EventManagement";
import NewsManagement from "../news-management/NewsManagement";
import ProfileSetting from "../profile-setting/ProfileSetting";
import { useLocation } from "react-router-dom";
import Profile from "../user-management/Profile";
import UserDetails from "../user-management/UserDetails";
import EventDetails from "../event-management/EventDetails";
import AddEvent from "../event-management/AddEvent";
import NewsDetails from "../news-management/NewsDetails";
import AddNews from "../news-management/AddNews";
import AddProfile from "../profile-setting/AddProfile";
import ChangeProfilePassword from "../profile-setting/ChangeProfilePassword";
import EditUserDetails from "../user-management/EditUserDetails";
import EditNewsDetails from "../news-management/EditNewsDetails";
import EditEventDetails from "../event-management/EditEvent";
// import Specialities from "../special/Specialities";
import Specialities from "../specialities/specialities";
import Badges from "../Badges/Badges";
import ViewBadges from "../Badges/ViewBadges";
import AddBadges from "../Badges/AddBadges";
import EditBadgesDetails from "../Badges/EditBadges";
// import AddSpecialities from "../specialities/AddSpecialities";
import Sponsor from "../Sponsor/Sponsor";
import VoiceType from "../voicetype/voicetype";
import VoiceLanguage from "../voicelanguage/voicelanguage";
import RoleManagement from "../role-management/RoleManagment";
import InApp from "../In-app-purchase/inApp";
import Connectivity from "../connectivity/connectivity";

const CommonComponent = () => {
  const history = useLocation();

  return (
    <div className="container-fluid ps-0">
      <div className="row">
        <div className="col-lg-2 min-height-cls using-min-height-cls">
          <Sidebar />
        </div>
        <div className="col-lg-10 mb-5 right-side-move-only">
          {/* user condition   */}
          {history.pathname === "/" && <UserManagement />}
          {history.pathname === "/user-management" && <UserManagement />}
          {history.pathname === "/user-management/profile" && (
            <Profile id={history.search.split("=")[1]} />
          )}
          {history.pathname === "/user-management/addUser" && <UserDetails />}
          {history.pathname === "/user-management/editUser" && (
            <EditUserDetails id={history.search.split("=")[1]} />
          )}

          {/* Role management condition   */}
          {history.pathname === "/role-management" && <RoleManagement />}

          {/* In-App Purchase condition   */}
          {history.pathname === "/membership-management" && <InApp />}

          {/* event condition  */}
          {history.pathname === "/event-management" && <EventManagement />}
          {history.pathname === "/event-management/EventDetails" && (
            <EventDetails id={history.search.split("=")[1]} />
          )}
          {history.pathname === "/event-management/AddEvent" && <AddEvent />}
          {history.pathname === "/event-management/EditEvent" && (
            <EditEventDetails id={history.search.split("=")[1]} />
          )}

          {/* news condition  */}
          {history.pathname === "/news-management" && <NewsManagement />}
          {history.pathname === "/news-management/NewsDetails" && (
            <NewsDetails id={history.search.split("=")[1]} />
          )}
          {history.pathname === "/news-management/AddNews" && <AddNews />}
          {history.pathname === "/news-management/editNews" && (
            <EditNewsDetails id={history.search.split("=")[1]} />
          )}

          {/* profile condition  */}
          {history.pathname === "/profile-setting" && <ProfileSetting />}
          {history.pathname === "/profile-setting/AddProfile" && (
            <AddProfile id={history.search.split("=")[1]} />
          )}
          {history.pathname === "/profile-setting/EditProfile" && (
            <AddProfile id={history.search.split("=")[1]} />
          )}
          {history.pathname === "/profile-setting/ChangePassword" && (
            <ChangeProfilePassword />
          )}

          {/* specialities condition   */}
          {history.pathname === "/specialities" && <Specialities />}

          {/* VoiceType condition   */}
          {history.pathname === "/voicetype" && <VoiceType />}

          {/* VoiceLanguage condition   */}
          {history.pathname === "/voicelanguage" && <VoiceLanguage />}

          {/* VoiceLanguage condition   */}
          {history.pathname === "/connectivity" && <Connectivity />}

          {/* sponsor condition   */}
          {history.pathname === "/Sponsor" && <Sponsor />}
          {/* {history.pathname === "/Sponsor/AddSponsor" && (
            <AddSpecialities id={history.search.split("=")[1]} />
          )}
          {history.pathname === "/Sponsor/ViewSponsor" && (
            <EditUserDetails id={history.search.split("=")[1]} />
          )} */}

          {/* badges condition   */}
          {history.pathname === "/badges" && <Badges />}
          {history.pathname === "/badges/ViewBadges" && (
            <ViewBadges id={history.search.split("=")[1]} />
          )}
          {history.pathname === "/badges/AddBadges" && <AddBadges />}
          {history.pathname === "/badges/editBadges" && (
            <EditBadgesDetails id={history.search.split("=")[1]} />
          )}

          {/* manage request condition   */}
          {/* {history.pathname === "/" &&  <UserManagement />}
          {history.pathname === "/user-management" &&  <UserManagement />}
          {history.pathname === "/user-management/profile" &&  <Profile id={history.search.split("=")[1]}/>}
          {history.pathname === "/user-management/addUser" &&  <UserDetails />}
          {history.pathname === "/user-management/editUser" &&  <EditUserDetails id={history.search.split("=")[1]}/>} */}

          {/* <EventManagement /> */}
          {/* <NewsManagement /> */}
          {/* <ProfileSetting /> */}
        </div>
      </div>
    </div>
  );
};

export default CommonComponent;
